import React from "react";
import {Title3} from "../../layouts/components/Titles";

const Ingredients = (props) => {
  const {product, className = "", style = {}} = props;

  return <div className={`pdp-ingredients ${className}`} style={style}>
    <Title3 className="text-strong margin-top-20 margin-bottom-10">
      {product.ingredients?.label}
    </Title3>
    <p dangerouslySetInnerHTML={{__html: product.ingredients?.value}} className="product-ingredients"/>
  </div>;
};

export default Ingredients;
